import { Button, Dropdown, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { FilterItem } from "models/types";
import "./filter-chip.scss";
import {
  CloseOutlined,
  CloseSquareOutlined,
  DownOutlined,
  UpOutlined
} from "@ant-design/icons";
import { DATE_FORMAT_MMDDYYYY, DateUtils } from "utils/dateutils";

type FilterChipProps = {
  items: FilterItem[];
  onChipDelete: (item: { field: string; value: string }) => void;
  onCategoryDelete: (item: FilterItem) => void;
  resetAll: Function;
};

function FilterChips(props: FilterChipProps) {
  const { items, onChipDelete, onCategoryDelete, resetAll } = props;
  const [filterItem, setFilterItem] = useState([] as Array<FilterItem>);
  const [openDropdown, setOpenDropdown] = useState(false);
  useEffect(() => {
    if (!items?.length) {
      setOpenDropdown(false);
      setFilterItem([] as Array<any>);
      return;
    }
    const filters = [] as Array<FilterItem>;
    (items || []).forEach((item) => {
      const colObj = {
        field: item?.field,
        header: item?.header,
        filter: item?.filter
      };
      filters.push(colObj);
    });
    setFilterItem(filters);
  }, [items]);
  const handleDelete = (item: any) => {
    onChipDelete(item);
  };

  const renderChip = (item: FilterItem, key: any) => {
    if (key === "") {
      return '""';
    }
    return key === null ? "(Blanks)" : key;
  };

  if (!filterItem.length) return null;

  return (
    <Dropdown
      data-testid="filter-chips-dropdown"
      placement="bottom"
      overlay={
        <div className="custom-filter-options" data-testid="index-dropdown">
          {filterItem.map((item, index) => {
            return (
              <div
                key={item.header || item.field}
                data-testid={`filter-chip-item${index}`}
              >
                <div className="custom-filter-header font-semibold mt-2 flex justify-between items-center">
                  {item.header}
                  <CloseSquareOutlined
                    className="rounded-lg text-ciq-red-800"
                    style={{ fontSize: 15 }}
                    onClick={() => onCategoryDelete(item)}
                  />
                </div>
                <div className="custom-filter-options__container">
                  {item.filter?.filterType &&
                  item.filter.filterType !== "set" ? (
                    <div
                      key={`k-${item.filter?.type}`}
                      className="flex flex-wrap gap-y-1 items-center custom-filter-values"
                    >
                      <Tooltip
                        title={
                          item.filter?.dateTo && item.filter?.dateFrom
                            ? `From: ${DateUtils.dateTimeObj(
                                item.filter.dateFrom
                              ).format(
                                DATE_FORMAT_MMDDYYYY
                              )} To: ${DateUtils.dateTimeObj(
                                item.filter?.dateTo
                              ).format(DATE_FORMAT_MMDDYYYY)}`
                            : ""
                        }
                      >
                        <div className="flex-1 truncate">
                          {`${item.filter?.type || ""}  ${
                            item.filter?.filter || ""
                          } ${
                            item.filter?.filterTo
                              ? ` to ${item.filter?.filterTo}`
                              : ""
                          } `}
                        </div>
                      </Tooltip>
                    </div>
                  ) : (
                    item?.filter?.values?.map((key: any) => {
                      return (
                        <div
                          key={`k-${key}`}
                          className="flex flex-wrap gap-y-1 items-center custom-filter-values"
                        >
                          <div className="flex-1 truncate">
                            {renderChip(item, key)}
                          </div>

                          <CloseOutlined
                            className="ml-2 mt-[1px] text-xs"
                            style={{ fontSize: 10, color: "gray" }}
                            onClick={() =>
                              handleDelete({
                                field: item.field,
                                value: key
                              })
                            }
                          />
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            );
          })}
          <div className="flex w-full justify-end custom-filter-divider pt-2">
            <Button
              className="text-ciq-red-800 border-ciq-red-800"
              onClick={() => {
                items.forEach((item) => {
                  onCategoryDelete(item);
                });
                resetAll();
              }}
              data-testid="index-button-clear-all"
            >
              Clear All
            </Button>
          </div>
        </div>
      }
      className="linking-container--nav__select"
      trigger={["click"]}
      open={openDropdown}
      onOpenChange={(open) => {
        setOpenDropdown(open);
      }}
    >
      <Button className="flex flex-wrap gap-y-1 items-center custom-filter-bar">
        Filter
        <div className="custom-filter-count bg-ciq-primary-900">
          {filterItem.length}
        </div>
        {openDropdown ? (
          <UpOutlined className="text-xs" />
        ) : (
          <DownOutlined className="text-xs" />
        )}
      </Button>
    </Dropdown>
  );
}

export default FilterChips;
